/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentCreateRespVo } from './PaymentCreateRespVo';
import {
    PaymentCreateRespVoFromJSON,
    PaymentCreateRespVoFromJSONTyped,
    PaymentCreateRespVoToJSON,
    PaymentCreateRespVoToJSONTyped,
} from './PaymentCreateRespVo';

/**
 * 
 * @export
 * @interface ResponsePaymentCreateRespVo
 */
export interface ResponsePaymentCreateRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePaymentCreateRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePaymentCreateRespVo
     */
    message?: string;
    /**
     * 
     * @type {PaymentCreateRespVo}
     * @memberof ResponsePaymentCreateRespVo
     */
    data?: PaymentCreateRespVo;
}

/**
 * Check if a given object implements the ResponsePaymentCreateRespVo interface.
 */
export function instanceOfResponsePaymentCreateRespVo(value: object): value is ResponsePaymentCreateRespVo {
    return true;
}

export function ResponsePaymentCreateRespVoFromJSON(json: any): ResponsePaymentCreateRespVo {
    return ResponsePaymentCreateRespVoFromJSONTyped(json, false);
}

export function ResponsePaymentCreateRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePaymentCreateRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PaymentCreateRespVoFromJSON(json['data']),
    };
}

export function ResponsePaymentCreateRespVoToJSON(json: any): ResponsePaymentCreateRespVo {
    return ResponsePaymentCreateRespVoToJSONTyped(json, false);
}

export function ResponsePaymentCreateRespVoToJSONTyped(value?: ResponsePaymentCreateRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PaymentCreateRespVoToJSON(value['data']),
    };
}

